import React, { useCallback } from 'react';

import WpButton from 'Wpds/components/button/WpButton';
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { AttachmentType } from 'Shared/constants/types';
import { downloadFile } from 'Shared/helpers';

import { getType } from './utils';
import { ContentType, PropsType } from './constants';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

function renderFilePreview(fileName: string): React.ReactNode {
  return (
    <div className="d-flex flex-column align-items-center text-center py-4">
      <WpIcon name="file" size="lg" />
      <span>{fileName}</span>
    </div>
  );
}

function renderPreview({ url, fileName }: AttachmentType, type: ContentType): React.ReactNode {
  switch (type) {
    case ContentType.IMAGE:
      return <img className="w-100 h-100" src={url} alt={fileName} />;
    case ContentType.PDF:
      return <iframe src={url} title={fileName} width="100%" style={{ height: '70vh' }} />;
    case ContentType.SVG:
    default:
      return renderFilePreview(fileName);
  }
}

function AttachmentPreviewModal({ attachment, isOpen, onToggle }: PropsType): React.ReactElement {
  const contentType = getType(attachment.contentType, attachment.isImage);

  const { isZoom } = useApp();

  const handleDownloadClick = useCallback(() => {
    if (isZoom) {
      (window as any).zoomSdk.openUrl({ url: attachment.url });
    } else {
      downloadFile({ url: attachment.url, filename: attachment.fileName });
    }
  }, [attachment.url, attachment.fileName]);

  return (
    <WpModal isOpen={isOpen} onToggle={onToggle} size="md">
      <WpModalHeader>{attachment.fileName}</WpModalHeader>
      <WpModalBody>{renderPreview(attachment, contentType)}</WpModalBody>
      <WpModalFooter>
        <WpButton onClick={handleDownloadClick}>Download</WpButton>
      </WpModalFooter>
    </WpModal>
  );
}

export default AttachmentPreviewModal;
